(function () {const ENABLED = false;
  const POPUP_COOLDOWN_MS = 10 * 60 * 1000;
  const STORAGE_KEY = 'payeo_popup_last_seen_at';

  // ✅ רק שלושת המוצרים האלו יפעילו את הפופאפ
  const ALLOWED_HANDLES = [
    'buddy-basic-kit',
    'מגן-מים-350',
    's9-מסיר-אבנית'
  ];

  const productCache = new Map();

  const money = cents => (cents / 100).toFixed(2);

  function canShowPopupNow() {
    const lastSeen = Number(localStorage.getItem(STORAGE_KEY) || 0);
    return Date.now() - lastSeen > POPUP_COOLDOWN_MS;
  }

  function markPopupShown() {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  }

  async function getCart() {
    return fetch('/cart.js').then(r => r.json());
  }

  async function getProductByHandle(handle) {
    if (productCache.has(handle)) {
      return productCache.get(handle);
    }

    const product = await fetch(`/products/${handle}.js`).then(r => r.json());
    productCache.set(handle, product);
    return product;
  }

  async function preloadCurrentProduct() {
    try {
      if (!window.location.pathname.includes('/products/')) return;

      // ✅ בדיקה שהדף הנוכחי הוא אחד מהמוצרים המותרים
      const isAllowed = ALLOWED_HANDLES.some(handle =>
        window.location.pathname.includes(encodeURIComponent(handle)) ||
        window.location.pathname.includes(handle)
      );
      if (!isAllowed) return;

      const product = await fetch(window.location.pathname + '.js').then(r => r.json());
      productCache.set(product.handle, product);

      console.log('Payeo popup: product preloaded', product.handle);
    } catch (error) {
      console.warn('Payeo popup: preload failed', error);
    }
  }

  function schedulePreload() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(preloadCurrentProduct);
    } else {
      setTimeout(preloadCurrentProduct, 1500);
    }
  }

  function getPayeoData(product, cartItem) {
    const payeoGroup = product.selling_plan_groups?.find(group =>
      group.app_id?.includes('payeo')
    );

    if (!payeoGroup) return null;

    const variant = product.variants?.find(v =>
      v.id === cartItem.variant_id &&
      v.selling_plan_allocations?.length
    );

    if (!variant) return null;

    const allocation = variant.selling_plan_allocations[0];

    const sellingPlan = payeoGroup.selling_plans.find(plan =>
      String(plan.id) === String(allocation.selling_plan_id)
    );

    if (!sellingPlan) return null;

    return { variant, allocation, sellingPlan };
  }

  async function findUpgradeableCartItems() {
    const cart = await getCart();
    const regularItems = cart.items.filter(item => !item.selling_plan_allocation);
    const upgradeableItems = [];

    for (const item of regularItems) {
      // ✅ דילוג על מוצרים שלא ברשימה המותרת
      if (!ALLOWED_HANDLES.includes(item.handle)) {
        console.log('Payeo popup: skipping item (not in allowed list)', item.handle);
        continue;
      }

      try {
        const product = await getProductByHandle(item.handle);
        const payeoData = getPayeoData(product, item);

        if (payeoData) {
          upgradeableItems.push({ item, product, ...payeoData });
        }
      } catch (error) {
        console.warn('Payeo popup: failed checking item', item.title, error);
      }
    }

    return upgradeableItems;
  }

  async function getCartSections() {
    const response = await fetch('/?sections=cart-drawer,cart-icon-bubble');
    return response.json();
  }

  async function refreshCartDrawer(cart) {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));

    const cartDrawer =
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('.cart-drawer');

    try {
      const sections = await getCartSections();

      if (cartDrawer?.renderContents) {
        cartDrawer.renderContents({ sections });
      }

      if (cartDrawer?.open) {
        cartDrawer.open();
      }

      cartDrawer?.classList?.add('active', 'is-open', 'open');
    } catch (error) {
      console.warn('Payeo popup: cart drawer section refresh failed', error);

      if (cartDrawer?.open) {
        cartDrawer.open();
      }

      cartDrawer?.classList?.add('active', 'is-open', 'open');
    }
  }

  async function upgradeAllCartItemsToPayeoSubscriptions() {
    const upgradeableItems = await findUpgradeableCartItems();

    for (const entry of upgradeableItems) {
      const { item, variant, allocation, sellingPlan } = entry;

      const payload = {
        id: variant.id,
        quantity: item.quantity,
        selling_plan: allocation.selling_plan_id,
        properties: {
          "_Subscription_Plan_ID": String(allocation.selling_plan_id),
          "חבילה": sellingPlan.name,
          "_Subscription_Plan_Name": sellingPlan.name,
          "_Subscription_Price_Per_Delivery": money(allocation.per_delivery_price),
          "_Subscription_Compare_At_Price": money(allocation.compare_at_price),
          "_Subscription_Discount_Type": sellingPlan.price_adjustments?.[0]?.value_type || "percentage",
          "_Subscription_Discount_Value": String(sellingPlan.price_adjustments?.[0]?.value || ""),
          "_Subscription_Currency": "₪"
        }
      };

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });
    }

    const updatedCart = await getCart();
    await refreshCartDrawer(updatedCart);
    return updatedCart;
  }

  function createPopup() {
    if (document.getElementById('payeo-subscription-popup')) return;

    const popup = document.createElement('div');
    popup.id = 'payeo-subscription-popup';
    popup.innerHTML = `
      <div class="payeo-popup-overlay">
        <div class="payeo-popup-box">
          <button class="payeo-popup-close" type="button">×</button>
          <div class="payeo-popup-icon">%</div>
          <h2>קבלו <span>15%</span> הנחה</h2>
          <p>
            קבלו 15% הנחה כבר ברכישה הקרובה בשדרוג למנוי.
            אפשר לשנות, להשהות או לבטל את המנוי בכל עת.
          </p>
          <button class="payeo-popup-upgrade" type="button">קבלו את ההטבה</button>
        </div>
      </div>
    `;

    document.body.appendChild(popup);

    popup.querySelector('.payeo-popup-close').addEventListener('click', hidePopup);

    popup.querySelector('.payeo-popup-overlay').addEventListener('click', function (event) {
      if (event.target.classList.contains('payeo-popup-overlay')) hidePopup();
    });

    popup.querySelector('.payeo-popup-upgrade').addEventListener('click', async function () {
      const button = this;
      button.disabled = true;
      button.textContent = 'מעדכן את העגלה...';

      try {
        await upgradeAllCartItemsToPayeoSubscriptions();
        // ✅ איפוס הטיימר אחרי שדרוג מוצלח — הלקוח יוכל לקבל את הפופאפ שוב
        localStorage.removeItem(STORAGE_KEY);
        hidePopup();
      } catch (error) {
        console.error('Payeo popup: upgrade failed', error);
        hidePopup();
        button.disabled = false;
        button.textContent = 'קבלו את ההטבה';
      }
    });
  }

  function showPopup() {
    createPopup();
    markPopupShown();
    document.getElementById('payeo-subscription-popup').style.display = 'block';
  }

  function hidePopup() {
    const popup = document.getElementById('payeo-subscription-popup');
    if (popup) popup.style.display = 'none';
  }

  async function maybeShowPopupAfterAddToCart() {
    if (!canShowPopupNow()) return;
    const upgradeableItems = await findUpgradeableCartItems();
    if (upgradeableItems.length > 0) showPopup();
  }

  function injectStyles() {
    if (document.getElementById('payeo-popup-style')) return;

    const style = document.createElement('style');
    style.id = 'payeo-popup-style';
    style.innerHTML = `
      #payeo-subscription-popup {
        display: none;
        position: fixed;
        inset: 0;
        z-index: 999999;
        direction: rtl;
      }

      .payeo-popup-overlay {
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.32);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 18px;
      }

      .payeo-popup-box {
        position: relative;
        width: min(92vw, 560px);
        background: #fff;
        border-radius: 28px;
        padding: 44px 32px 34px;
        text-align: center;
        box-shadow: 0 18px 60px rgba(0,0,0,.18);
        font-family: inherit;
      }

      .payeo-popup-close {
        position: absolute;
        top: 18px;
        left: 22px;
        border: 0;
        background: transparent;
        font-size: 38px;
        line-height: 1;
        cursor: pointer;
        color: #222;
      }

      .payeo-popup-icon {
        margin: 0 auto 16px;
        width: 78px;
        height: 78px;
        border-radius: 50%;
        background: #f3e8f7;
        color: #713090;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 42px;
        font-weight: 900;
      }

      .payeo-popup-box h2 {
        margin: 0 0 14px;
        font-size: clamp(36px, 7vw, 58px);
        font-weight: 900;
        color: #111;
      }

      .payeo-popup-box h2 span {
        color: #713090;
      }

      .payeo-popup-box p {
        margin: 0 auto 28px;
        max-width: 460px;
        font-size: clamp(18px, 3.8vw, 24px);
        line-height: 1.55;
        color: #222;
      }

      .payeo-popup-upgrade {
        width: 100%;
        max-width: 420px;
        border: 0;
        border-radius: 18px;
        background: #713090;
        color: #fff;
        padding: 19px 24px;
        font-size: clamp(22px, 5vw, 31px);
        font-weight: 900;
        cursor: pointer;
        box-shadow: 0 8px 18px rgba(113,48,144,.25);
      }

      .payeo-popup-upgrade:disabled {
        opacity: .7;
        cursor: wait;
      }

      /* ===== מובייל: פופאפ קומפקטי ===== */
      @media (max-width: 768px) {
        .payeo-popup-box {
          padding: 22px 22px 20px;
          border-radius: 20px;
        }

        .payeo-popup-close {
          top: 10px;
          left: 14px;
          font-size: 26px;
        }

        .payeo-popup-icon {
          width: 50px;
          height: 50px;
          font-size: 24px;
          margin-bottom: 8px;
        }

        .payeo-popup-box h2 {
          font-size: 28px;
          font-weight: 950;
          margin-bottom: 6px;
        }

        .payeo-popup-box p {
          font-size: 15px;
          line-height: 1.4;
          margin-bottom: 14px;
        }

        .payeo-popup-upgrade {
          padding: 13px 20px;
          font-size: 18px;
          border-radius: 12px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function listenToAddToCart() {if (!ENABLED) return;
    const originalFetch = window.fetch;

    window.fetch = async function (...args) {
      const response = await originalFetch.apply(this, args);

      try {
        const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
        if (url && url.includes('/cart/add')) {
          setTimeout(maybeShowPopupAfterAddToCart, 300);
        }
      } catch (error) {
        console.warn('Payeo popup: fetch listener error', error);
      }

      return response;
    };
  }

  injectStyles();
  createPopup();
  listenToAddToCart();
  schedulePreload();

  window.showPayeoPopup = showPopup;
  window.upgradeAllCartItemsToPayeoSubscriptions = upgradeAllCartItemsToPayeoSubscriptions;
})();